export enum PreventiveQueueEnum {
  PENDING = "PENDING",
  ON_COUNTER_PROPOSAL = "ON_COUNTER_PROPOSAL",
  ACCEPTED = "ACCEPTED",
  LOST = "LOST"
}

export enum PreventiveQueueMessageEnum {
  PENDING_CLIENT_APPROVAL = "PENDING_CLIENT_APPROVAL"
}
